import { PageNotFound } from '@crehana/compass.ui/page-not-found';

const WhatsappTemplatesEditNotFound = () => {
  return <PageNotFound />;
};

export default WhatsappTemplatesEditNotFound;
